module.exports = __webpack_public_path__ + "static/media/export.c88f2aff.png";